<div class="modal fade" id="dialogAnular" tabindex="-1" role="dialog" aria-labelledby="Anular" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Anulação de Pré-Liquidação</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="accordion" id="accordion" >
          <div class="card">
            <div class="card-header">
              <button (click)="buscarAnulacoes()" class="btn btn-sm" data-toggle="collapse"
                data-target="#collapseHistorico" aria-expanded="false" aria-controls="collapseHistorico">
                <em class="fa fa-history" style="margin: 0 10px 0 -10px"></em>Histórico de anulações
              </button>
            </div>
            <div class="collapse" id="collapseHistorico" aria-labelledby="bloco-historico" data-parent="#accordion">
              <div class="card-body p-0">
                <table class="table table-eddy">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" class="text-center">Data</th>
                      <th scope="col">Usuário</th>
                      <th scope="col" class="text-right">Valor</th>
                      <th scope="col">Histórico</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listAnulacoes">
                      <td class="text-center">{{item.data_liquidacao | date:'dd/MM/yyyy':'GMT'}}</td>
                      <td>{{item.usuario_cadastro ? item.usuario_cadastro.nome : item.usuario_cadastro}}</td>
                      <td class="text-right">{{item.valor_liquidado | number:'1.2-2'}}</td>
                      <td>{{item.historico}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <button class="btn btn-sm" data-toggle="collapse" data-target="#collapseAnulacao" aria-expanded="false"
                aria-controls="collapseAnulacao">
                <em class="fa fa-undo" style="margin: 0 10px 0 -10px"></em>Dados da anulação
              </button>
            </div>
            <div class="collapse show" id="collapseAnulacao" aria-labelledby="bloco-anulacao" data-parent="#accordion">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <label for="data_liquidacao_anulacao">Data anulação<span class="text-danger">*</span></label>
                    <p-calendar [(ngModel)]="data" id="data_liquidacao_anulacao"
                      inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR"
                      [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
                    </p-calendar>
                  </div>
                  <div class="col-md-4">
                    <label for="data_referencia">Data referência<span class="text-danger">*</span></label>
                    <p-calendar [(ngModel)]="data_referencia" id="data_referencia"
                      inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR"
                      [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
                    </p-calendar>
                  </div>
                  <div class="col-md-4">
                    <label for="valor_liquidado_anulacao">Valor anulação<span class="text-danger">*</span></label>
                    <input unmask="typed" [imask]="imaskConfig" type="text" class="form-control text-right"
                      id="valor_liquidado_anulacao" [(ngModel)]="valor" placeholder="0,00"
                      style="font-weight: bold; color: #1e88e5">
                  </div>
                </div>
                <hr class="mt-2 mb-3" />
                <div class="row">
                  <div class="col-md-12">
                    <label for="historico_anulacao">Justificativa<span class="text-danger">*</span></label>
                    <textarea [(ngModel)]="historico" class="form-control" id="historico_anulacao" rows="7"></textarea>
                  </div>
                </div>
              </div>
              <br>
              <br>
              <div class="card-footer p-3" style="z-index: 0;">
                <button (click)="anular()" type="submit"
                  class="btn btn-danger btn-sm float-right ml-2">Confirmar</button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
